<template>
  <div class="hbn-container" id="userInfo">
    <div class="search-form">
      <el-row :gutter="24">
        <el-col :span="18">
          <el-form
            ref="form"
            :model="form"
            label-width="80px"
            label-position="top"
            size="mini"
          >
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="单据编号">
                  <el-input
                    id="DJBH"
                    v-model="Log.DJBH"
                    placeholder="单据编号"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="6">
          <el-form-item style="padding-top: 28px">
            <el-button size="mini" class="hbn-button-serach" @click="SearchOpt"
              >查找</el-button
            >
            <span class="control-collapse" @click="show = !show">{{
              show ? "收起" : "展开"
            }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </div>

    <div class="hbn-table-screen">
      <div class="custom-table-layer">
        <div style="margin-bottom: 13px">
          <vxe-table
            :data="DataList"
            round
            border
            height="388"
            class="mytable-scrollbar"
            style="width: 100%"
            :highlight-current-row="true"
            ref="multipleTable"
            highlight-hover-row
            highlight-hover-column
            highlight-current-column
            show-overflow="tooltip"
            :tooltip-config="{enterable:true}"
            empty-text="没有更多数据了！"
            resizable
            stripe
          >
            <vxe-table-column
              fixed="left"
              type="checkbox"
              width="40"
            ></vxe-table-column>
            <vxe-table-column
              fixed="left"
              type="seq"
              width="55"
              title="序号"
              align="center"
            ></vxe-table-column>
            <vxe-table-column
              v-for="(item, key) in LogList"
              :key="key"
              :field="item.prop"
              :title="item.label"
              align="center"
              show-overflow-tooltip
              :sortable="item.order"
            
            />
          </vxe-table>
        </div>


        <div class="pagination">
                <vxe-pager perfect size="mini"
                :current-page="pageData.currentPage"
                :page-size="pageData.currentSize"
                :page-sizes="pageData.pagesizes"
                :total="pageData.total"
                :pager-count="5"
              :layouts="[
              'PrevJump',
              'PrevPage',
              'JumpNumber',
              'NextPage',
              'NextJump',
              'FullJump',
              'Sizes',
              'Total',
            ]" @page-change="handlePageChange">
            </vxe-pager>
            <!-- </div> -->
        </div>


      </div>
    </div>
  </div>
</template>

<script>
import { Search } from "@element-plus/icons";
import { LogList } from "@/assets/apiData/Log";
// import {GetLogInfo } from "@api/user";
import {
    ref,
    reactive,
    toRefs,
    computed,
    onMounted,
    watch,
    getCurrentInstance,
    watchEffect,
} from "vue";


export default {
    setup(props) {
     
      onMounted(()=>{
        SearchOpt();
      });

      //分页
     const handlePageChange = ({ currentPage, pageSize }) => {
      if (pageData.currentSize != pageSize) {
        debugger
        pageData.currentPage = 1; //说明更改了每页展示条数，要从第一页进行展示
        pageData.currentSize = pageSize;
      } else {
        pageData.currentPage = currentPage;
      }
      SearchOpt();
    };


     function SearchOpt() {
       let  Condition=[{
         Key:'DJBH',
         Values:[data.Log.DJBH]
       }]
       data.pageData.conditions=Condition;
       console.log(JSON.stringify(data.pageData))
       /*
        GetLogInfo(JSON.stringify(data.pageData))
            .then(function (result) {
                debugger;
                if (result.status == 200) {
                    data.pageData.total =  ref(result.data.total);
                    data.DataList = result.data.list;
                } else {
                    console.log("日志查询", error);
                }
            })
            .catch((error) => {
                console.log("日志查询", error);
            });
        */
      }

      //SJ
      const  data =reactive(
        {
          DataList:[],
          Log:{
            DJBH:""
          },
          pageData:{
              tabledatas: [],
              currentPage: 1,
              currentSize: 20,
              pagesizes: [20, 50, 100, 500],
              total: 0,
              conditions: [],
              orderbyCloums: "DJBH",
          }
        }
      );

      return{
         ...toRefs(data),
         LogList,
         SearchOpt,
         handlePageChange
     
      }
    }
}
</script>

<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/reset-input";

.custom-table-header>th {
    background: #dfdfdf !important;
}

.custom-table-header>th>.cell {
    font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
    font-weight: 500;
    color: #868686 !important;
    line-height: 22px;
}

.custom-table-layer ::v-deep .el-table .cell {
    color: #32383d;
}

.el-table .cell {
    color: #32383d;
}

.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
    display: none;
}

.custom-table-layer .el-pagination.is-background .btn-prev,
.custom-table-layer .el-pagination.is-background .btn-next,
.custom-table-layer .el-pagination.is-background .el-pager li {
    border: 1px solid #acb5bd;
    width: 32px;
    height: 32px;
    line-height: 32px;
    background-color: #fff;
}

/*滚动条整体部分*/
.mytable-scrollbar ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

/*滚动条的轨道*/
.mytable-scrollbar ::-webkit-scrollbar-track {
    background-color: #ffffff;
}

/*滚动条里面的小方块，能向上向下移动*/
.mytable-scrollbar ::-webkit-scrollbar-thumb {
    background-color: #bfbfbf;
    border-radius: 5px;
    border: 1px solid #f1f1f1;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.mytable-scrollbar ::-webkit-scrollbar-thumb:hover {
    background-color: #a8a8a8;
}

.mytable-scrollbar ::-webkit-scrollbar-thumb:active {
    background-color: #787878;
}

/*边角，即两个滚动条的交汇处*/
.mytable-scrollbar ::-webkit-scrollbar-corner {
    background-color: #ffffff;
}

.page-left {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
}

.operation {
    display: flex;
}

.pagination {
    margin: 0;
    width: 100%;
    /* position: absolute;
        bottom: 0; */
    background-color: #fff;
    z-index: 7;
    padding: 5px 0;
}
</style><style lang="scss" scoped>
@import "@/common/css/Hbn_modules/hbn-base-model";

#userInfo {}
</style>
<style scoped>
</style>
